<div [hidden]="hideElements">
  <p>
    {{ title || 'Loading...' }}
  </p>
</div>
